import { apiService } from "@/common/api.service.js";

export default {
  companyInfo() {
    const endpoint = "/company";
    return apiService(endpoint);
  },
  recordUserInteraction(payload) {
    const endpoint = `/api/user-interaction/`;
    return apiService(endpoint, "POST", payload);
  },
};